import { render, staticRenderFns } from "./matrix.vue?vue&type=template&id=cfb451e2&scoped=true"
import script from "./matrix.vue?vue&type=script&lang=js"
export * from "./matrix.vue?vue&type=script&lang=js"
import style0 from "./matrix.vue?vue&type=style&index=0&id=cfb451e2&prod&lang=less&scoped=true"
import style1 from "./matrix.vue?vue&type=style&index=1&id=cfb451e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb451e2",
  null
  
)

export default component.exports